import ArrowLeft from "@/components/Svg/ArrowLeft";
import { DataBannerTypes } from "@/types/BannerType";
import Image from "next/image";
import Link from "next/link";
import React from "react";
function FourBannerWith2Section({ dataTemplate }: DataBannerTypes) {
  const fourBannerLink = `pt-[50%] lg:pt-[30%]  rounded-[0.75rem]  sm:rounded-[1.5rem]  lg:rounded-3xl relative  overflow-hidden border`;
  const fourBannerImageClass = `w-full h-full object-cover rounded-[0.75rem] sm:rounded-[1.5rem] lg:rounded-3xl absolute inset-0 hover:filter z-20 hover:blur-[2px] transition-all duration-300"`;
  const fourBannerParentSpan = `absolute bottom-0 flex  items-end justify-center z-30  w-full rounded-b-2xl lg:rounded-b-3xl  h-max text-white md:text-base sm:text-base text-xs lg:text-xl xl:text-2xl`;
  const fourBannerSpan = `xl:p-6 sm:p-6 p-4  text-right  flex  items-center gap-2 lg:gap-6    w-full bg-gradient-to-t z-30 from-[#1A1818] to-transparent`;
  const fourBannerArrow = `stroke-[#FFC20A]`;
  return (
    <div className="grid    grid-cols-1  min-[450px]:grid-cols-2 gap-3 xl:gap-10 my-5  lg:my-5 lg:px-16 px-6">
      {dataTemplate?.map((fourBannerData, index) => (
        <Link
          key={index + 1}
          href={fourBannerData?.link ?? "/"}
          className={fourBannerLink}
          style={{ order: Number(fourBannerData?.positionInTemplate) }}
        >
          <Image
            priority
            fetchPriority="high"
            sizes="100vw"
            unoptimized
            src={fourBannerData?.patchImage ?? "/images/default.png"}
            quality={100}
            width={5000}
            height={3000}
            className={fourBannerImageClass}
            alt={`banner-${index + 1}`}
          />
          <span className={fourBannerParentSpan}>
            <span className={fourBannerSpan}>
              {fourBannerData?.title}
              <ArrowLeft className={fourBannerArrow} />
            </span>
          </span>
        </Link>
      ))}
    </div>
  );
}

export default FourBannerWith2Section;
